/* eslint-disable no-underscore-dangle */
import {put,call,takeLatest} from 'redux-saga/effects';
import { GET_ANALYTICS_ADDRESS, GET_ANALYTICS_BAR,
   GET_ANALYTICS_PURPOSE, GET_ANA_CARDS } from '../action/constant';
import request from '../utils/request';
import { tzParam } from '../utils/timezone';
import { getAnaAddressSuccess,
  getAnaAddressError, getAnaBarSuccess
  , getAnaBarError, getAnaCardsSuccess,
  getAnaCardsError, getAnaPurposeSuccess,
  getAnaPurposeError } from '../action/analyticsAction';

  const token = localStorage.getItem('token');


function* getAnaAddressSaga(){
const data = JSON.parse(localStorage.getItem('building'));
const url = `Visitor/nameaddress?buildingId=${data._id}`;
 try{
   const response = yield call(request,url,{
     method:'GET',
     headers:{
      Accept:'applicatin/json',
      Authorization:`VMS-2.0${token}`,
    }
   });
  yield put(getAnaAddressSuccess(response.data.data));
 }
 catch(err){
  yield put(getAnaAddressError(err.response))
 }
}
function* getAnaBarSaga(){
  const data = JSON.parse(localStorage.getItem('building'));
const url = `Visitor/bar?buildingId=${data._id}&${tzParam()}`;
try{
 const response = yield call(request,url,{
   method:'GET',
   headers:{
     Accept:'applicatin/json',
     Authorization:`VMS-2.0${token}`,
   }
 });
 yield put(getAnaBarSuccess(response.data.data));
}
catch(err){
 yield put(getAnaBarError(err));
}
}

function* getAnaCardSaga(){
  const data = JSON.parse(localStorage.getItem('building'));
 const url = `Visitor/cards?buildingId=${data._id}&${tzParam()}`;
 try{
   const response =  yield call(request,url,{
     method:'GET',
     headers:{
       Accept:'application/json',
       Authorization:`VMS-2.0${token}`,
     }
   });
   yield put(getAnaCardsSuccess(response.data.data));
 }
 catch(err){
  yield put(getAnaCardsError(err.response));
 }
}
function* getAnaPurposeSaga(){
  const data = JSON.parse(localStorage.getItem('building'));
 const url = `Visitor/purposecompany?buildingId=${data._id}`;
  try {
   const response = yield call(request,url,{
     method:'GET',
     headers:{
       Accept:'application/json',
       Authorization:`VMS-2.0${token}`,
     }
   });
   yield put(getAnaPurposeSuccess(response.data.data));
  }
  catch(err){
   yield put(getAnaPurposeError(err.response));
  }
}
export default function* watchingAnalyticsSaga(){
  yield takeLatest(GET_ANALYTICS_ADDRESS.PENDING,getAnaAddressSaga);
  yield takeLatest(GET_ANALYTICS_BAR.PENDING,getAnaBarSaga);
  yield takeLatest(GET_ANALYTICS_PURPOSE.PENDING,getAnaPurposeSaga);
  yield takeLatest(GET_ANA_CARDS.PENDING,getAnaCardSaga);
}
